<forge-text-field [invalid]="isInvalid" [required]="isRequired" density="small" [ngClass]="textFieldClasses"
  [showClear]="showClearButton" (forge-text-field-clear)="clearText()">
  <input #input type="text" [name]="controlName" [formControl]="formControl" (selectionChange)="onSelectionChanged()"
    autocomplete="off" [attr.spellcheck]="browserSpellcheck()">

    @if (!hideLabel) {
      <label slot="label">{{label}}</label>
    }

    @if (showMaxLengthHint) {
      <span slot="support-text-end">{{length}}/{{maxLength}}</span>
    }

    @if (showSupportText) {
      <span class="error" slot="support-text">
        @if (showErrorMessage('required')) {
          {{label}} is required
        }
        @if (showErrorMessage('minlength')) {
          {{label}} must be at least {{minLength}} characters long
        }
        @if (showErrorMessage('maxlength')) {
          {{label}} cannot be longer than {{maxLength}} characters
        }
        @if (hasCustomValidators) {
          @for (customError of customErrors; track customError) {
            @if (showErrorMessage(customError.errorKey)) {
              {{customError.message}}
            }
          }
        }
      </span>
    }
    @if (tooltip) {
      <forge-tooltip>{{tooltip}}</forge-tooltip>
    }
  </forge-text-field>